import { EventManager, Events } from "@events";
import { ref } from "vue";

export function useCallState(rtcId) {
  const eventEmitter = EventManager.getEventEmitter(rtcId);

  const callData = ref(undefined);
  const role = ref("");
  const name = ref("");
  const agentToken = ref("");

  const isInitiator = ref(false);
  const audioMuted = ref(false);
  const videoMuted = ref(false);
  const remoteAudioMuted = ref(false);
  const remoteVideoMuted = ref(false);
  const isHeld = ref(false);
  const isDisconnected = ref(false);
  const preventPageClose = ref(false);
  const muteEvents = ref(false);
  const disableVideoControls = ref(false);
  const callDataLoadedPromise = ref(new Promise((resolve) => {
    eventEmitter.on(Events.CallDataReceived, () => {
      resolve();
    });
  }));

  const webrtcConnectedPromise = ref(new Promise((resolve) => {
    eventEmitter.on(Events.WebRTCConnected, () => {
      resolve();
    });
  }));

  const setMuteEvents = (mute) => {
    console.log("call state " + rtcId + " set mute events " + mute);
    muteEvents.value = mute;
  };

  const setIsDisconnected = (disconnected) => {
    isDisconnected.value = disconnected;
  };

  const setPreventPageClose = (prevent) => {
    preventPageClose.value = prevent;
  };

  const setName = (newName) => {
    console.log("call state " + rtcId + " set name " + newName);
    name.value = newName;
  };

  const setRole = (newRole) => {
    console.log("call state " + rtcId + " set role " + newRole);
    role.value = newRole;
  };

  const setAgentToken = (token) => {
    console.log("call state " + rtcId + " set agent token " + token);
    agentToken.value = token;
  };

  const setCallData = (data) => {
    callData.value = data;
    console.log("call state " + rtcId + " set call data " + JSON.stringify(data));
    eventEmitter.emit(Events.CallDataReceived, data);
  };

  const setAudioMuted = (muted) => {
    audioMuted.value = muted;
    if (muted) {
      eventEmitter.emit(Events.AudioMuted);
    } else {
      eventEmitter.emit(Events.AudioUnmuted);
    }
  };

  const setVideoMuted = (muted) => {
    videoMuted.value = muted;
    if (muted) {
      eventEmitter.emit(Events.VideoMuted);
    } else {
      eventEmitter.emit(Events.VideoUnmuted);
    }
  };

  const setRemoteAudioMuted = (muted) => {
    remoteAudioMuted.value = muted;
  };

  const setRemoteVideoMuted = (muted) => {
    remoteVideoMuted.value = muted;
  };

  const setIsHeld = (held) => {
    isHeld.value = held;
  };

  const getInteractionId = () => {
    return callData?.value?.interactionId || "noint";
  };

  const setInteractionId = (interactionId) => {
    callData.value.InteractionId = interactionId;
    eventEmitter.emit(Events.InteractionIdChanged, interactionId);
  };

  const setDisableVideoControls = (disable, reason) => {
    disableVideoControls.value = disable;
    if(reason) console.log("disableVideoControls:", disable, "reason:", reason);
  }

  return {
    callData,
    role,
    name,
    isInitiator,
    audioMuted,
    videoMuted,
    remoteAudioMuted,
    remoteVideoMuted,
    isHeld,
    preventPageClose,
    isDisconnected,
    muteEvents,
    disableVideoControls,
    callDataLoadedPromise,
    webrtcConnectedPromise,
    setIsDisconnected,
    setCallData,
    setName,
    setRole,
    setAgentToken,
    setAudioMuted,
    setVideoMuted,
    setRemoteAudioMuted,
    setRemoteVideoMuted,
    setIsHeld,
    getInteractionId,
    setInteractionId,
    setPreventPageClose,
    setMuteEvents,
    setDisableVideoControls,
  };
}
